// thai-production build: every user is Thai-speaking and in the Thailand
// region. Components read `user.preferredLanguage` / `user.region` (from
// context or straight from localStorage) to pick names, copy and categories,
// so a stored "en" or another region would leak English / other countries.
// This pins both on any user object before it is stored or used.
export const THAI_LANGUAGE = "th";
export const THAI_REGION = "healjai";

export function thaiUser<T>(user: T): T {
  if (!user || typeof user !== "object") return user;
  return {
    ...(user as any),
    preferredLanguage: THAI_LANGUAGE,
    region: THAI_REGION,
  } as T;
}

/** Rewrites the user already saved in localStorage (call once at startup). */
export function normalizeStoredUser(): void {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return;
    localStorage.setItem("user", JSON.stringify(thaiUser(JSON.parse(raw))));
    localStorage.setItem("userRegion", THAI_REGION);
  } catch {
    // ignore storage / parse errors
  }
}
